/// <reference path="ListaEmpresas.js" />

var oConfiguracion;

function GetObjConfiguracion() {
    if (oConfiguracion == undefined) {
        oConfiguracion = new ObjConfiguracion();
    }
    return oConfiguracion;
}

function ObjConfiguracion() {
    var that = this;

    this.Inicializar = function () {
        that.setFeria();
        that.setVersionPIM();
        that.idio = 'es';
        if (getQueryVariable('idioma').toLowerCase() === 'es')
            that.cambiarIdioma("es");
        else {
            if (getQueryVariable('idioma').toLowerCase() === 'en')
                that.cambiarIdioma("en");
        }
    }

    this.GetImagenEmpresaSinLogo = function (fichero) {
        var pathImg = GetObjConfiguracion().GetRutaFichero("R", fichero);
        return new RSVP.Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () {
                resolve(pathImg);
            }
            img.onerror = function (e) {
                reject(e);
            }
            img.src = pathImg;
        });
    }

    this.LoadImagenesPorDefecto = function () {
        this.GetImagenEmpresaSinLogo("sinlogo.jpg").then(function (ruta) {
            that.logoDefectoEsp = ruta;
        }).catch(function (){
            that.logoDefectoEsp = "img/sinlogo150.jpg";
        });

        this.GetImagenEmpresaSinLogo("sinlogo_en.jpg").then(function (ruta){
            that.logoDefectoEng = ruta;
        }).catch(function () {
            this.GetImagenEmpresaSinLogo("sinlogo.jpg").then(function (ruta) {
                that.logoDefectoEng = ruta;
            }).catch(function () {
                that.logoDefectoEsp = "img/sinlogo150.jpg";
            });
        });

    }

    this.getRutaImagenPorDefecto = function () {
        if (that.idio == "es")
            return that.logoDefectoEsp;
        else
            return that.logoDefectoEng;
    }
    

    //[ALTIA] Carga dinámica de colores corporativos de la feria
    this.cargaColoresCorporativos = function () {
        $.ajax({
            type: "GET",
            url: that.GetRutaFichero("R", "colores.xml"),
            dataType: "xml",
            success: function (xml) {
                
                $(xml).find('c').each(function () {
                    that.arrayEstilos[$(this).attr('id')] = $(this).attr('v');
                });
                
                if ($(xml).length == 0) {
                    that.arrayEstilos['contraste'] = "#2931b3";
                    that.arrayEstilos['textoOscuro'] = "#4e4e4e";
                    that.arrayEstilos['fondoCabecera'] = "#FFFFFF";
                    that.arrayEstilos['fondoPie'] = "#FFFFFF";
                    that.arrayEstilos['logoFeria'] = "none";
                    //that.arrayEstilos['logoIFEMA'] = "https://www.ifema.es/general/img/ifema-feria-madrid/color.png";

                    $('#logoCabecera').addClass('hidden');
                }
                else {
                    $('#logoCabecera').attr('src', GetObjConfiguracion().arrayEstilos['logoFeria']);
                }
                $('#textoOscuro').attr('src', that.arrayEstilos['textoOscuro'] = "#4e4e4e");
                //$('#logoIFEMA').attr('src', that.arrayEstilos['logoIFEMA']);

                // script para el correcto funcionamiento de variables CSS en IExplorer
                $.getScript('https://cdn.jsdelivr.net/npm/css-vars-ponyfill@2', function () {
                    cssVars({
                        variables: {
                            'contrast-color': that.arrayEstilos['contraste'],
                            'dark-text-color': that.arrayEstilos['textoOscuro'],
                            'bg-header': that.arrayEstilos['fondoCabecera'],
                            'bg-footer': that.arrayEstilos['fondoPie']
                        }
                    });
                });
				// FIN script para el correcto funcionamiento de variables CSS en IExplorer
            },
            error: function (jqXHR, textStatus, errorThrown) {
                that.arrayEstilos['contraste'] = "#2931b3";
                that.arrayEstilos['textoOscuro'] = "#4e4e4e";
                that.arrayEstilos['fondoCabecera'] = "#FFFFFF";
                that.arrayEstilos['fondoPie'] = "#FFFFFF";
                that.arrayEstilos['logoFeria'] = "none";
                //that.arrayEstilos['logoIFEMA'] = "https://www.ifema.es/general/img/ifema-feria-madrid/color.png";

                $('#logoCabecera').addClass('hidden');
                //$('#logoIFEMA').attr('src', GetObjConfiguracion().arrayEstilos['logoIFEMA']);

                // script para el correcto funcionamiento de variables CSS en IExplorer
                $.getScript('https://cdn.jsdelivr.net/npm/css-vars-ponyfill@2', function () {
                    cssVars({
                        variables: {
                            'contrast-color': that.arrayEstilos['contraste'],
                            'dark-text-color': that.arrayEstilos['textoOscuro'],
                            'bg-header': that.arrayEstilos['fondoCabecera'],
                            'bg-footer': that.arrayEstilos['fondoPie']
                        }
                    });
                });
                // FIN script para el correcto funcionamiento de variables CSS en IExplorer
            }
        })
    }
	//FIN [ALTIA]
    this.cargaLogoIfemaGetRecursos = function () {
        var urlLlamar = "../getRecursoWeb.ashx";
        $.ajax({
            type: "GET",
            url: urlLlamar,
            cache: false,
            success: function (response) {
                var data = response;
                that.arrayEstilos['logoIFEMA'] = data;
                that.arrayEstilos['logoIFEMApie'] = data;
                $('#logoIFEMA').attr('src', that.arrayEstilos['logoIFEMA']);
                $('#logoIFEMApie').attr('src', that.arrayEstilos['logoIFEMApie']);
            },
            error: function (response) {
                console.log(response);
            }
        });
    }

    this.GetRutaFichero = function (strTipo, strNombreFichero) {
        var strRuta = "";
        if ((that.feria == "") || (that.feria == undefined))
            that.setFeria();
        strRuta = that.RutaRecurso + 'Feria=' + that.feria + '&Tipo=' + strTipo + '&Fichero=' + strNombreFichero;
        return strRuta;
    }

    this.EsRecintoPersonalizado = function () {
        return (that.arrayParametros['recintoper'] == "S" ? true : false);
    }

    this.setFeria = function () {
        that.feria = getQueryVariable('feria').toUpperCase();
    }

    this.setPaises = function (onTerminate) {
        if (that.feria) {
            var urlLlamar = "../wsListaExpositores.svc/GetIndiceMaestro?Feria=" + that.feria +
                "&tipoBusqueda=TODO&numero=999&pagina=1&Tipoindice=PR&idioma=" + that.idio;
            $.ajax({
                type: "GET",
                url: urlLlamar,
                data: "{}",
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                cache: false,
                success: function (response) {
                    var data = eval(response.d);
                    onTerminate(data);
                },
                error: function (response) {
                    //alert('Error: ' + response);
                }
            });
        }
    }

    this.setPaisesCallback = function (data) {
        var paises = new Array();
        if (data != null) {
            for (i = 0; i < data.d.length; i++) {
                paises.push({ label: data.d[i].no, value: data.d[i].id });
            }
        }
        that.arrayPaises = paises;
        //GetObjListaEmpresas().eventosInterfazGrafica();
        GetObjListaEmpresas().eventosBusquedaCruzada();
        if (GetObjConfiguracion().paisId != "") {
            var nombrePais = GetObjListaEmpresas().obtenerNombrePais();
            $("#busquedaCruzada, #busquedaCruzadaMovil").val(nombrePais);
        }
    }

    //se llama una vez se ha cargado configuracion.xml
    this.inicializaConfiguracion = function (data) {
        if (data != null) {
            for (i = 0; i < data.length; i++) {
                //DDC necesito esto para recintoper. Habría que unificar las dos formas de cargar los parametros
                that.arrayParametros[data[i].id] = data[i].v;

                if (data[i].id == "fechaCatalogo")
                    that.fechaCarga = data[i].v;
                if (data[i].id == "fechaFinFeria")
                    that.fechaFinFeria = data[i].v;
                if (data[i].id == "actMapa")
                    that.opMapa = (data[i].v == "S" ? true : false);
                if (data[i].id == "activarPais")
                    that.opPais = (data[i].v == "S" ? true : false);
                if (data[i].id == "activarSector")
                    that.opSector = (data[i].v == "S" ? true : false);
                if (data[i].id == "activarActividad")
                    that.opActividad = (data[i].v == "S" ? true : false);
                if (data[i].id == "activarProducto")
                    that.opProducto = (data[i].v == "S" ? true : false);
                if (data[i].id == "activarRepresentada")
                    that.opRepresentada = (data[i].v == "S" ? true : false);
                if (data[i].id == "activarMarca")
                    that.opMarca = (data[i].v == "S" ? true : false);
                if (data[i].id == "activarStand")
                    that.opStand = (data[i].v == "S" ? true : false);
                if (data[i].id == "actCita")
                    that.opCita = ((data[i].v == "S" && that.verPIM == "N") ? true : false);
                if (data[i].id == "actCargCom")
                    that.cargaCompleta = (data[i].v == "S" ? true : false);
                if (data[i].id == "actDatPost")
                    that.opDatosPostales = (data[i].v == "S" ? true : false);

            }
        }
        
        that.numPagina = 1;
        if (that.verPIM == 'S')
            that.numEmpresas = 10;//20 maem77
        else
            that.numEmpresas = 20;//20 maem77
        that.tipoBusqueda = 'TODO'; //todos
        
        that.setPaises(that.setPaisesCallback);
    }


    this.inicializaFichaUI = function () {
        FichaUI.mostrarPlano(that.opMapa);
        FichaUI.mostrarDatosPostales(that.opDatosPostales);
        FichaUI.verCita(that.opCita);
    }


    this.actualizarFiltrosBusquedaListaEmpresas = function (idioma, numeroPagina, numeroEmpresas, tipoBusqueda, txtBusqueda, codGen) {
        if (idioma != "")
            that.idio = idioma;
        if (numeroPagina != "")
            that.numPagina = numeroPagina;
        if (numeroEmpresas != "")
            that.numEmpresas = numeroEmpresas;
        if (tipoBusqueda != "")
            that.tipoBusqueda = tipoBusqueda;
        if (txtBusqueda != "")
            that.textoBusqueda = txtBusqueda;
        if (codGen)
            that.codigoGenerico = codGen;
        //console.log("Idioma: "+that.idio+" NumeroPagina: "+that.numPagina+" NumeroEmpresas: "+that.numEmpresas+" tipoBusqueda: "+that.tipoBusqueda+" txtBusqueda: "+that.textoBusqueda);
    }

    this.actualizarTextoNumeroResultados = function () {
        var numInf = (that.numEmpresas * (that.numPagina - 1)) + 1;
        var numSuperior = that.numEmpresas * that.numPagina;
        var auxSuperior = numSuperior > that.numTotalEmpresas ? that.numTotalEmpresas : numSuperior;

        if (that.idio == "es")
            CatalogoWebUI.resultadosPagina(numInf + " - " + auxSuperior + " de " + that.numTotalEmpresas);
        else

            CatalogoWebUI.resultadosPagina(numInf + " - " + auxSuperior + " of " + that.numTotalEmpresas);
    }

    this.actualizarNumPaginaEmpresas = function (numEmpresasPorPagina) {
        var modulo = GetObjConfiguracion().numTotalEmpresas % numEmpresasPorPagina;
        var nPagina = GetObjConfiguracion().numPagina
        var nTotal;
        if (modulo > 0)
            nTotal = parseInt(GetObjConfiguracion().numTotalEmpresas / numEmpresasPorPagina) + 1;
        else
            nTotal = parseInt(GetObjConfiguracion().numTotalEmpresas / numEmpresasPorPagina);
        if (nPagina > nTotal) 
            GetObjConfiguracion().numPagina = nTotal;
    }

    this.cambiarIdioma = function (idioma) {
        that.idio = idioma;
    }

    this.opcionFiltroTxt = function () {
            var resultado = "";
            if (that.busquedaActiva == "T")
                resultado = "Todas las empresas";
            else if (that.busquedaActiva == "A")
                resultado = "Actividad";
            else if (that.busquedaActiva == "S")
                resultado = "Sector";
            else if (that.busquedaActiva == "P")
                resultado = "País/Provincia";
            else if (that.busquedaActiva == "O")
                resultado = "Productos";
            else if (that.busquedaActiva == "R")
                resultado = "Representadas";
            else if (that.busquedaActiva == "M")
                resultado = "Marcas";
            else
                resultado = "Genéricas";

            return resultado;
    }

    this.actualizarDatosBusqueda = function () {

        if (that.menuPrincipalActivo == "E") {
            that.actualizarTextoNumeroResultados();

            if (that.busquedaActiva == "T")
                GetObjListaEmpresas().cargarListaEmpresas();
            else if (that.busquedaActiva == "A" && GetObjConfiguracion().filtroBusquedaActiva == "")
                GetObjControlador().cargarListaActividades(that.idio, that.numPagina, that.numEmpresas, that.tipoBusqueda, that.textoBusqueda);
            else if (that.busquedaActiva == "S" && GetObjConfiguracion().filtroBusquedaActiva == "")
                GetObjControlador().cargarListaSectores(that.idio, that.numPagina, that.numEmpresas, that.tipoBusqueda, that.textoBusqueda);
            else if (that.busquedaActiva == "P" && GetObjConfiguracion().filtroBusquedaActiva == "")
                GetObjControlador().cargarListaPaises(that.idio, that.numPagina, that.numEmpresas, that.tipoBusqueda, that.textoBusqueda);
            else if (that.busquedaActiva == "O" && GetObjConfiguracion().filtroBusquedaActiva == "")
                GetObjControlador().cargarListaProductos(that.idio, that.numPagina, that.numEmpresas, that.tipoBusqueda, that.textoBusqueda);
            else if (that.busquedaActiva == "R" && GetObjConfiguracion().filtroBusquedaActiva == "")
                GetObjControlador().cargarListaRepresentadas(that.idio, that.numPagina, that.numEmpresas, that.tipoBusqueda, that.textoBusqueda);
            else if (that.busquedaActiva == "M" && GetObjConfiguracion().filtroBusquedaActiva == "")
                GetObjControlador().cargarListaMarcas(that.idio, that.numPagina, that.numEmpresas, that.tipoBusqueda, that.textoBusqueda);
            else if (that.busquedaActiva == "ST" && GetObjConfiguracion().filtroBusquedaActiva == "")
                GetObjControlador().cargarListaStands(that.idio, that.numPagina, that.numEmpresas, that.tipoBusqueda, that.textoBusqueda);
            else
                GetObjControlador().cargarListaGenericos(that.idio, that.numPagina, that.numEmpresas, that.tipoBusqueda, that.textoBusqueda, that.codigoGenerico);

            if (GetObjConfiguracion().filtroBusquedaActiva != "") {
                GetObjControlador().cargarListaEmpresas("", "", "", "", "");
                GetObjControlador().visualizarEmpresas();
            }

        }
        if (that.menuPrincipalActivo == "F") {
            that.actualizarTextoNumeroResultados();
            GetObjListaEmpresas().cargarListaEmpresasFavoritas();
        }
        
        // Lineas que corrigen lo siguiente:
        // En IE8 cuando cambia el idioma, si el campo esta vacio,
        // se establece como valor del campo el de placeholder.
        if (GetObjConfiguracion().tipoBusqueda != "CONTIENE") {
            $("#busquedaNormal, #txtBuscarMovil").val("");
        }
        if (GetObjConfiguracion().paisId == "") {
            $("#busquedaCruzada, #busquedaCruzadaMovil").val("");
        }
        GetObjConfiguracion().setPaises(GetObjConfiguracion().setPaisesCallback);
    }

    this.setValoresImpresion = function () {

        //ficha empresa 
        if (that.menuPrincipalActivo == "D") {
            that.codEmpresa = '';
            if (location.hash.indexOf('?') > 0) {
                that.codEmpresa = sacaParametro('emp', location.hash);
            }
        }
        else
            that.codEmpresa = '';

        //mapa
        if (that.menuPrincipalActivo == "M") {

            if (location.hash.search("#MAPA_FERIA") >= 0) {
                if (location.hash.indexOf('?') > 0) {
                    that.stand = sacaParametro('s', location.hash);
                }
                that.opMapaActiva = "F";
            }

            if (location.hash.search("#MAPA_PABELLON") >= 0) {
                if (location.hash.indexOf('?') > 0) {
                    that.pabellon = sacaParametro('p', location.hash);
                    that.stand = sacaParametro('s', location.hash);
                }
                that.opMapaActiva = "P";
            }
        }
        else {
            that.pabellon = '';
            that.stand = '';
        }

    }

    this.setVersionPIM = function () {
        if (getQueryVariable('MODO').toUpperCase() === 'PIM') {
            that.verPIM = 'S';
            that.opCita = false;
        }
        else
            that.verPIM = 'N';
    }

};

//cargaCompleta: true - con todos los datos
//               false - carga mínima, sin País, Sector, etc. Sólo tiene Todas las empresas.
ObjConfiguracion.prototype = {
    feria: '',
    idio: 'es',
    logoDefectoEsp: '',
    logoDefectoEng: '',
    activarEventosPagina: false,
    //-- 
    numPagina: 1,
    numEmpresas: 10,  //numero de empresas que se ven
    numTotalEmpresas: 0, //número total de empresas para el filtro actual
    tipoBusqueda: 'TODO',
    textoBusqueda: '',
    filtroBusquedaActiva: '', //corresponde por ejemplo al id del sector seleccionado // id del pais seleccionado etc
    //-- busqueda activa
    //T - todas las empresas, P - paises, S - Sectores, A - actividad, M - marcas, ST - Stands, R - repre, O - Productos
    busquedaActiva: 'T',
    //E - expositor, F - favoritos, M - mapas
    menuPrincipalActivo: 'E',
    // codigo de generico que se esta buscando
    codigoGenerico: '',
    arrayOpcionesBusqueda: ["T", "P", "S", "A", "M", "ST", "R", "O", "F", "MAPA"],

    verPIM: 'N',
    pabellon: '',
    stand: '',
    opMapaActiva: '', //F - Feria, P - Pabellón
    codEmpresa: '',
    nombreEmpresa: '',
    verImpresion: false,  //false - versión normal /// true varsión de impresión  

    arrayParametros: new Array(),
    arrayEstilos: new Array(), //[ALTIA] carga dinamica de colores corporativos
    arrayPaises: new Array(),
    paisId: '',
    RutaRecurso: '../getrecurso.ashx?',
    arrayIndice: new Array(),

    //-- opciones de carga
    fechaCarga: '',
    //diaCarga: '',
    //mesCarga: '',
    //anioCarga:'',
    fechaFinFeria:'',
    mostrarRepresentada: true,
    mostrarMarcas: true,
    mostrarDatosPostales: true,
    mostrarlocalizacion: true,
    mostrarplano: true,
    cargaCompleta: true,

    //-- opciones visuales --
    opMapa: true,
    opPais: false,
    opSector: false,
    opActividad: false,
    opProducto: false,
    opRepresentada: false,
    opMarca: false,
    opStand: false,
    opCita: false,
    opEspecifico: false,
    opDatosPostales: false
    //opPlano:false,
}